module.exports = __webpack_public_path__ + "static/media/login_bg.7db80d2e.jpg";